import $ from 'jquery';

// use this id on any page theres a coalition search
$('#coalition-search-submit').click(function () {
  $(this).parents('form').submit();
});
